<template>
  <div class="gm-segment-stats flex flex-row">
    <div
      v-for="stat in statsData"
      :key="stat.id"
      class="gm-segment-stats__item w-1/4 flex flex-col justify-center items-center align-center"
    >
      <div
        class="
          border-2
          text-primary
          border-primary
          rounded-full
          h-16
          w-16
          flex
          items-center
          justify-center
        "
      >
        <component
          v-bind:is="stat.icon"
          class="h-7 w-7"
        ></component>
      </div>
      <div class="flex flex-col justify-center items-center align-center mt-2">
        <p class="text-grey-800 text-xl font-semibold">
          {{ stat.value }}
        </p>
        <p class="text-md text-grey-600">
          {{ stat.label }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SegmentStats',

  props: {
    statsData: {
      required: true,
    },
  },
};
</script>

<style scoped>
.gm-segment-stats {
  flex-wrap: wrap;
  gap: 14px 0;
}

.gm-segment-stats__item {
  min-width: 0;
}

@media (max-width: 640px) {
  .gm-segment-stats__item {
    width: 50%;
  }
}
</style>
